// src/backgrounds/constants.ts
var ADDON_ID = "storybook/background", PARAM_KEY = "backgrounds";
var EVENTS = {
  UPDATE: `${ADDON_ID}/update`
};

// src/measure/constants.ts
var ADDON_ID2 = "storybook/measure-addon", TOOL_ID = `${ADDON_ID2}/tool`, PARAM_KEY2 = "measureEnabled", EVENTS2 = {
  RESULT: `${ADDON_ID2}/result`,
  REQUEST: `${ADDON_ID2}/request`,
  CLEAR: `${ADDON_ID2}/clear`
};

// src/outline/constants.ts
var ADDON_ID3 = "storybook/outline", PARAM_KEY3 = "outline";

// src/backgrounds/defaults.ts
var DEFAULT_BACKGROUNDS = {
  light: { name: "light", value: "#F8F8F8" },
  dark: { name: "dark", value: "#333" }
};

export {
  ADDON_ID,
  PARAM_KEY,
  DEFAULT_BACKGROUNDS,
  ADDON_ID2,
  TOOL_ID,
  PARAM_KEY2,
  ADDON_ID3,
  PARAM_KEY3
};
